export default __webpack_public_path__ + "static/media/warning--dual-lanes-go-straight-or-turn-right--g1.2b80e972.png";